var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1683.7,
    height: 2748.8,
    viewBox: "0 0 445.5 727.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "Y",
    x1: -230.4,
    x2: -371.9,
    y1: 528.9,
    y2: 829,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0debfc",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fa0582",
      stopOpacity: 1
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "Z",
    x1: -161.4,
    x2: -289,
    y1: 737.4,
    y2: 546.3,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "aa",
    x1: -593.8,
    x2: -511.9,
    y1: 1009.7,
    y2: 795.1,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "ac",
    x1: 969.5,
    x2: 643.4,
    y1: 571.4,
    y2: 509.4,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "ad",
    x1: -806.2,
    x2: -660.5,
    y1: 783.4,
    y2: 485.3,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "ae",
    x1: -370.3,
    x2: -228.7,
    y1: 824.3,
    y2: 524.2,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 179.7,
    x2: 217.7,
    y1: 773.2,
    y2: 870.8,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 179.8,
    x2: 217.9,
    y1: 775.4,
    y2: 873,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: -652.7,
    x2: -634.6,
    y1: 339.7,
    y2: 439.7,
    gradientTransform: "translate(140.7 29.4) scale(1.031)",
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    x1: -1241.9,
    x2: -1066.1,
    y1: 394.9,
    y2: 394.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "l",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "r",
    x1: -1066.2,
    x2: -1112.7,
    y1: 231.6,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "w",
    x1: -1074.2,
    x2: -1098.9,
    y1: 241.8,
    y2: 466.2,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "A",
    x1: -1079.2,
    x2: -1083.6,
    y1: 252.2,
    y2: 478,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "B",
    x1: -1123.9,
    x2: -1066.1,
    y1: 394.9,
    y2: 394.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "F",
    x1: -1050.3,
    x2: -1106,
    y1: 487.8,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "G",
    x1: -1142.7,
    x2: -1063,
    y1: 394.9,
    y2: 394.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "L",
    x1: -1062.4,
    x2: -1107.3,
    y1: 473.8,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "M",
    x1: -1154.1,
    x2: -1063,
    y1: 394.9,
    y2: 394.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "R",
    x1: -1066.4,
    x2: -1107.3,
    y1: 457.9,
    y2: 235.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "S",
    x1: -1162.8,
    x2: -1063,
    y1: 394.9,
    y2: 394.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "X",
    x1: -1065.8,
    x2: -1102.7,
    y1: 441.2,
    y2: 218.4,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "h",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "i",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "k",
    x1: -1058.7,
    x2: -1123.2,
    y1: 222.1,
    y2: 438.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "m",
    x1: -1066.2,
    x2: -1112.7,
    y1: 231.6,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "n",
    x1: -1066.2,
    x2: -1112.7,
    y1: 231.6,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "o",
    x1: -1066.2,
    x2: -1112.7,
    y1: 231.6,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "p",
    x1: -1066.2,
    x2: -1112.7,
    y1: 231.6,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "q",
    x1: -1066.2,
    x2: -1112.7,
    y1: 231.6,
    y2: 452.6,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "s",
    x1: -1074.2,
    x2: -1098.9,
    y1: 241.8,
    y2: 466.2,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "t",
    x1: -1074.2,
    x2: -1098.9,
    y1: 241.8,
    y2: 466.2,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "u",
    x1: -1074.2,
    x2: -1098.9,
    y1: 241.8,
    y2: 466.2,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "v",
    x1: -1074.2,
    x2: -1098.9,
    y1: 241.8,
    y2: 466.2,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "x",
    x1: -1079.2,
    x2: -1083.6,
    y1: 252.2,
    y2: 478,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "y",
    x1: -1079.2,
    x2: -1083.6,
    y1: 252.2,
    y2: 478,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "z",
    x1: -1079.2,
    x2: -1083.6,
    y1: 252.2,
    y2: 478,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "C",
    x1: -1050.3,
    x2: -1106,
    y1: 487.8,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "D",
    x1: -1050.3,
    x2: -1106,
    y1: 487.8,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "E",
    x1: -1050.3,
    x2: -1106,
    y1: 487.8,
    y2: 269,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "H",
    x1: -1062.4,
    x2: -1107.3,
    y1: 473.8,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "I",
    x1: -1062.4,
    x2: -1107.3,
    y1: 473.8,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "J",
    x1: -1062.4,
    x2: -1107.3,
    y1: 473.8,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "K",
    x1: -1062.4,
    x2: -1107.3,
    y1: 473.8,
    y2: 252.5,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "N",
    x1: -1066.4,
    x2: -1107.3,
    y1: 457.9,
    y2: 235.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "O",
    x1: -1066.4,
    x2: -1107.3,
    y1: 457.9,
    y2: 235.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "P",
    x1: -1066.4,
    x2: -1107.3,
    y1: 457.9,
    y2: 235.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "Q",
    x1: -1066.4,
    x2: -1107.3,
    y1: 457.9,
    y2: 235.9,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "T",
    x1: -1065.8,
    x2: -1102.7,
    y1: 441.2,
    y2: 218.4,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "U",
    x1: -1065.8,
    x2: -1102.7,
    y1: 441.2,
    y2: 218.4,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "V",
    x1: -1065.8,
    x2: -1102.7,
    y1: 441.2,
    y2: 218.4,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "W",
    x1: -1065.8,
    x2: -1102.7,
    y1: 441.2,
    y2: 218.4,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "ab",
    x1: -593.8,
    x2: -511.9,
    y1: 1009.7,
    y2: 795.1,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1441.2 -1456.6) scale(3.06755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m232.1 791-.7 3.2a54 54 0 0 1-10.9 18.7c-4.8 5.9-9.7 9-16.1 14.4-5 4.2-10.7 7.8-15.4 12.5-3.5 3.4-7 7-10.3 10.7a71 71 0 0 0-8 10.6c-3.4 5.8-6.6 10.7-8.3 16.5a57 57 0 0 0 .5 31.8c1.6 3.8 2.8 5.8 2.8 5.8s-1.3-2-3-5.7a58.6 58.6 0 0 1-2-32.4c1.4-6.2 4.5-11.5 7.7-17.4a75 75 0 0 1 7.7-11.4c3.2-4 6.6-7.7 10-11.4 4.9-5.3 10.5-9.3 14.9-13.4 6.4-6 11-9 14.7-14.3a48.5 48.5 0 0 0 8.9-16.7l.4-2.2.4-2.7.6-6.2c.2-2.5.5-4 .7-5.2l.6-1.7.2-.5h.2v-.1a29 29 0 0 1 1.5 0c.4 0 .8 0 1.2.3.5.2 1 .7 1.3 1.5.5 1 1 2.8 1 5.4a41.2 41.2 0 0 1-.6 10z",
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.747,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "translate(-629 -298.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.7 794.5v.2c0 1 .1 7.2 1.3 10.9.8 2.5 2 5.3 3.9 7.9 1.6 2 3.2 4.3 5.2 6 2.4 1.9 4.3 4 6.6 5.5 2.2 1.4 4.3 2.8 6.6 3.9l7.7 4.1c2.2 1.3 4.6 2.3 6.8 3.7 1.7 1.1 3.5 2 5 3.1a17.8 17.8 0 0 1 7 7.8l.5 2.2.2 2v2l-.2 1.3v.8h.2-.3v-2.1l-.1-2-.4-1.9-.7-2c-.4-.9-1-1.7-1.8-2.5a19.5 19.5 0 0 0-5.3-4l-5.4-2.5c-2-1-4.4-1.8-7-3a145 145 0 0 0-8-3.2c-2.5-1-5-2.3-7.2-3.4-3.3-1.7-5.6-3.9-7.7-5.2-2.8-2-5-4.4-6.8-6.4a32 32 0 0 1-5.8-9.4 45 45 0 0 1-3-12.3c-.2-2.9 0-5 .4-6.5.8-3.7 2.2-4 2.2-4 2.8-.3 5-.5 5.8 3.1.3 1.5.3 3.2.2 5.9z",
    style: {
      opacity: 1,
      fill: "url(#c)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.500098,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-629.2 -300.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.1,
    height: 5.9,
    x: -537.2,
    y: 388.4,
    rx: 6.7,
    ry: 2.9,
    style: {
      opacity: 1,
      fill: "url(#d)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 6.246,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    transform: "rotate(-11)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#e)",
      fillOpacity: 1
    },
    transform: "rotate(-37.9 -1181.7 -2126.3) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 2.3,
    x: -1105,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#f)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#g)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#h)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#i)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 2.5,
    x: -1247.7,
    y: 393.5,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#j)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.1,
    height: 2.3,
    x: -1172.6,
    y: 393.7,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#k)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.7,
    height: 2.3,
    x: -1134.3,
    y: 393.7,
    ry: 1.1,
    style: {
      opacity: 1,
      fill: "url(#l)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-33.2 -1280 -2485.4) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 2.3,
    x: -1105,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#m)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#n)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#o)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 0.9,
    style: {
      opacity: 1,
      fill: "url(#p)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.3,
    height: 2.8,
    x: -1216.8,
    y: 393.3,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#q)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.7,
    height: 2.3,
    x: -1134.3,
    y: 393.7,
    ry: 1.1,
    style: {
      opacity: 1,
      fill: "url(#r)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-27.6 -1433.1 -3067.4) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 2.3,
    x: -1105,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#s)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#t)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#u)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#v)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.2,
    height: 2.5,
    x: -1170.8,
    y: 393.6,
    ry: 1.1,
    style: {
      opacity: 1,
      fill: "url(#w)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-22.4 -1641.6 -3852.7) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6,
    height: 2.3,
    x: -1129,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#x)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#y)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#z)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.1,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#A)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#B)",
      fillOpacity: 1
    },
    transform: "rotate(173 -692.6 393.6) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4,
    height: 2.3,
    x: -1123.9,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#C)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#D)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#E)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.3,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#F)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#G)",
      fillOpacity: 1
    },
    transform: "rotate(170.2 -695.4 404.7) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 2.3,
    x: -1105,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#H)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#I)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#J)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#K)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.2,
    height: 2.3,
    x: -1142.7,
    y: 393.7,
    ry: 0.7,
    style: {
      opacity: 1,
      fill: "url(#L)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#M)",
      fillOpacity: 1
    },
    transform: "rotate(169.1 -698.9 402.4) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 2.3,
    x: -1105,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#N)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#O)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#P)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#Q)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 2.3,
    x: -1154.1,
    y: 393.7,
    ry: 0.9,
    style: {
      opacity: 1,
      fill: "url(#R)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#S)",
      fillOpacity: 1
    },
    transform: "rotate(168.1 -693.4 395.9) scale(1.42275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6,
    height: 2.3,
    x: -1105,
    y: 393.7,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#T)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.9,
    height: 2.3,
    x: -1087.8,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#U)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.7,
    height: 2.3,
    x: -1077.1,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#V)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 2.3,
    x: -1069.4,
    y: 393.7,
    rx: 1.2,
    ry: 1.2,
    style: {
      opacity: 1,
      fill: "url(#W)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.3,
    height: 2.3,
    x: -1162.8,
    y: 393.7,
    ry: 0.9,
    style: {
      opacity: 1,
      fill: "url(#X)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0188185,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#Y)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-286 574.6c2.9-4.5 5.4-8.1 7.3-10.5 5.7-7.6 7.4-7.8 7.4-7.8l.4.3-.4-.3s.5 2.4-3.3 10.4c-1.5 3-3.3 6.4-6 11l-2 3.4c-1.8 3.3-5.1 9-7.7 15a114 114 0 0 0-7 20 97.8 97.8 0 0 0 .8 47c1.4 6 3.6 11.9 5.8 17.1a112 112 0 0 0 8.8 17.7 81.6 81.6 0 0 0 9.8 13 78 78 0 0 1-20.6-29.8 110.6 110.6 0 0 1-11.3-42c-.4-8.4.1-16.5 1.5-24.1a126 126 0 0 1 16.6-40.4z",
    style: {
      fill: "url(#Z)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(693.4 -644.3) scale(1.57934)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#aa)",
      fillOpacity: 1
    },
    transform: "rotate(-54.6 -1290.3 -275.5) scale(1.57934)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "url(#ab)",
      fillOpacity: 1
    },
    transform: "translate(183.8 330.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.2,
    height: 6.1,
    x: 648.5,
    y: 550.6,
    rx: 0.3,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#ac)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5.08087,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    transform: "matrix(-.99994 -.01094 -.0084 .99996 0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.4,
    height: 6.1,
    x: -721.9,
    y: 532.1,
    rx: 0.4,
    ry: 0.8,
    style: {
      opacity: 1,
      fill: "url(#ad)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 5.4025,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    transform: "scale(1 -1) rotate(74.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#aaa8c6",
      fillOpacity: 1,
      stroke: "#aaa8c6",
      strokeWidth: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "m-175 581.5 5.8 12.8c2.1 5 5.2 12.2 7.4 19.7a177.1 177.1 0 0 1 6.5 44.8 156.2 156.2 0 0 1-7.6 50.1 356.6 356.6 0 0 1-29.9 72.9c-8 14.8-17.7 29.8-25 41.1a2720 2720 0 0 1-24.8 36.4l-2.2 3.2-.6.9-.2.2a60 60 0 0 0 .2.2l-.2-.2.2-.2.6-1 2.2-3.2 7.2-11c4-6 10.8-16.4 16.6-26a409 409 0 0 0 41.3-81.6c4-10.8 7.5-21.8 10.4-32.9a151.1 151.1 0 0 0 6.2-48.7c-.3-8.3-1.3-16.4-2.6-23.7a142.4 142.4 0 0 0-12.2-38 429.3 429.3 0 0 0-9.3-18.8l-7.9-14.7c-1.5-3-2.5-5-3-6.5l-.8-2.1v-.7a1 1 0 0 1 0-.2 26.2 26.2 0 0 1 .4-.2l.7-.4h1.3c.6 0 1.3.3 2.2 1a30 30 0 0 1 4.7 5.5 128.1 128.1 0 0 1 12.4 21.3z",
    style: {
      fill: "url(#ae)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(690.7 -637) scale(1.57934)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-221.7 614.5-8.6 23.6-9.2-23.6 1.7-2.5 3.2-4.6 4.5-6.6z",
    style: {
      fill: "#6f12b1",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#26d2ef",
      strokeWidth: 6.2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(689.5 -631.1) scale(1.57934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-221.7 614.5-8.6 31.6-9.2-31.6 1.7-2.5 3.2-4.6 4.5-6.6z",
    style: {
      fill: "#26d2ef",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6f12b1",
      strokeWidth: 6.2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(180 -49.3 591.6) scale(1.57934)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-221.7 614.5-8.6 31.6-9.2-31.6 1.7-2.5 3.2-4.6 4.5-6.6z",
    style: {
      fill: "#26d2ef",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6f12b1",
      strokeWidth: 6.2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "rotate(180 9.2 591.6) scale(1.57934)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2d27c9ffcbf78b3d8ee9c08d715dd483.svg";
export { ForwardRef as ReactComponent };